import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { mediaUrl, userInitials } from "@/lib/media";
import { cn } from "@/lib/utils";

const SIZES = {
    xs: { box: "size-7", text: "text-[10px]" },
    sm: { box: "size-8", text: "text-[11px]" },
    md: { box: "size-11", text: "text-sm" },
    lg: { box: "size-20", text: "text-lg" },
    xl: { box: "size-24", text: "text-xl" },
};

export default function UserAvatar({ user, size = "sm", className, fallbackClassName }) {
    const { box, text } = SIZES[size] || SIZES.sm;
    const src = mediaUrl(user?.avatar_url);

    return (
        <Avatar className={cn(box, "border border-[#F0E8DC]", className)}>
            {src && (
                <AvatarImage
                    src={src}
                    alt={user?.full_name || "Profile"}
                    className="object-cover"
                />
            )}
            <AvatarFallback
                className={cn(
                    "bg-gradient-to-br from-[#FDE8E8] to-[#F5EDE0] font-bold text-[#4A0E17]",
                    text,
                    fallbackClassName,
                )}
            >
                {userInitials(user?.full_name)}
            </AvatarFallback>
        </Avatar>
    );
}
